const baseUrl =
  process.env.REACT_APP_BASE_URL || "https://api.ecomdropship.ai/";

const ALLOWED = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
  "application/pdf",
];
const MAX_BYTES = 5 * 1024 * 1024;

export const validateSupportFile = (file) => {
  if (!ALLOWED.includes(file.type)) {
    return "Only images (JPEG, PNG, WebP, GIF) and PDF are allowed";
  }
  if (file.size > MAX_BYTES) {
    return "Each file must be 5MB or less";
  }
  return null;
};

const uploadSupportFileToS3 = async (file) => {
  if (!file) throw new Error("No file provided");
  const err = validateSupportFile(file);
  if (err) throw new Error(err);

  const filename = encodeURIComponent(file.name);
  const contentType = encodeURIComponent(file.type);
  const presignedResponse = await fetch(
    `${baseUrl}support/presign?filename=${filename}&contentType=${contentType}`,
    { credentials: "include" }
  );
  if (!presignedResponse.ok) {
    const text = await presignedResponse.text();
    throw new Error(`Failed to get upload URL: ${text}`);
  }
  const { url, key, publicUrl } = await presignedResponse.json();
  const uploadResponse = await fetch(url, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file,
  });
  if (!uploadResponse.ok) throw new Error("Failed to upload file");
  return {
    url: publicUrl || url.split("?")[0],
    s3Key: key,
    fileName: file.name,
    mimeType: file.type,
    sizeBytes: file.size,
  };
};

export default uploadSupportFileToS3;
